module.exports = __webpack_public_path__ + "img/dwhtest_schema.acf50437.svg";